module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"profile_image":"プロフィール画像","change_image":"画像を変更する","error_occurred":"エラーが発生しました。","cancel":"キャンセル","save":"保存","user_name":"ユーザー名","file_type":"ファイル形式：JPG, PNG","file_size":"ファイルサイズ：600px 以内 30kb以下","dont_empty_user_name":"ユーザー名は空にできません。","invaild_image":"の拡張子は対応していません。","updated":"ユーザー情報を更新しました。"}}')
  delete Component.options._Ctor
}
